(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sebbi-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Smooth back-to-top */
    document.querySelectorAll('[data-sf-totop]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    /* Live opening hours per boutique block */
    var ALIASES = {
      sun: 0, sunday: 0, zo: 0, zon: 0, dom: 0,
      mon: 1, monday: 1, ma: 1, maa: 1, lun: 1,
      tue: 2, tues: 2, tuesday: 2, di: 2, din: 2, mar: 2,
      wed: 3, weds: 3, wednesday: 3, wo: 3, woe: 3, mie: 3,
      thu: 4, thur: 4, thurs: 4, thursday: 4, do: 4, don: 4, jue: 4,
      fri: 5, friday: 5, vr: 5, vri: 5, vie: 5,
      sat: 6, saturday: 6, za: 6, zat: 6, sab: 6
    };
    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    function dayIndex(token) {
      token = (token || '').toLowerCase().replace(/[^a-z]/g, '');
      if (ALIASES[token] != null) return ALIASES[token];
      var key = token.slice(0, 3);
      return ALIASES[key] != null ? ALIASES[key] : -1;
    }
    function expandDays(text) {
      var range = text.split(/[–—\-]| to | t\/m | até /i);
      if (range.length >= 2) {
        var a = dayIndex(range[0]), b = dayIndex(range[range.length - 1]);
        if (a > -1 && b > -1) {
          var out = [], i = a;
          for (var g = 0; g < 7; g++) { out.push(i); if (i === b) break; i = (i + 1) % 7; }
          return out;
        }
      }
      var s = dayIndex(text);
      return s > -1 ? [s] : [];
    }
    function parseTime(text) {
      if (!text || /closed|gesloten|cerrado|fermé|chiuso/i.test(text)) return null;
      var nums = text.match(/(\d{1,2})[:.](\d{2})/g);
      if (!nums || nums.length < 2) return null;
      function m(s) { var p = s.split(/[:.]/); return parseInt(p[0], 10) * 60 + parseInt(p[1], 10); }
      return [m(nums[0]), m(nums[1])];
    }
    function fmt(min) {
      var h = Math.floor(min / 60), mm = min % 60;
      return (h < 10 ? '0' + h : h) + ':' + (mm < 10 ? '0' + mm : mm);
    }

    document.querySelectorAll('[data-boutique]').forEach(function (root) {
      var hoursEl = root.querySelector('[data-boutique-hours]');
      var statusEl = root.querySelector('[data-boutique-status]');
      var statusText = root.querySelector('[data-boutique-status-text]');
      if (!hoursEl) return;

      var tz = root.getAttribute('data-timezone') || 'Europe/Madrid';
      var todayIdx, nowMin;
      try {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
        }).formatToParts(new Date());
        var bag = {};
        parts.forEach(function (p) { bag[p.type] = p.value; });
        var hr = parseInt(bag.hour, 10); if (hr === 24) hr = 0;
        todayIdx = dayIndex(bag.weekday);
        nowMin = hr * 60 + parseInt(bag.minute, 10);
      } catch (e) {
        var d = new Date();
        todayIdx = d.getDay();
        nowMin = d.getHours() * 60 + d.getMinutes();
      }
      if (todayIdx < 0) return;

      var schedule = {};
      hoursEl.querySelectorAll('div[data-day]').forEach(function (row) {
        var days = expandDays(row.getAttribute('data-day') || '');
        var time = parseTime(row.getAttribute('data-time') || '');
        var isToday = false;
        days.forEach(function (dd) { schedule[dd] = time; if (dd === todayIdx) isToday = true; });
        row.classList.toggle('is-today', isToday);
      });

      if (!statusEl || !statusText) return;

      var today = schedule[todayIdx];
      var open = false, msg = 'Closed';

      if (today && nowMin >= today[0] && nowMin < today[1]) {
        open = true;
        msg = 'Open now · until ' + fmt(today[1]);
      } else if (today && nowMin < today[0]) {
        msg = 'Closed · opens today ' + fmt(today[0]);
      } else {
        for (var step = 1; step <= 7; step++) {
          var idx = (todayIdx + step) % 7;
          if (schedule[idx]) {
            var when = step === 1 ? 'tomorrow' : DAYS[idx];
            msg = 'Closed · opens ' + when + ' ' + fmt(schedule[idx][0]);
            break;
          }
        }
      }

      statusText.textContent = msg;
      statusEl.classList.toggle('is-open', open);
      statusEl.classList.toggle('is-closed', !open);
      statusEl.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sebbi-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sebbi-pdp]').forEach(function (root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';

      var form = root.querySelector('form[data-type="add-to-cart-form"]');
      var hiddenId = root.querySelector('.js-variant-id');

      /* measure the sticky top stack (marquee + header) and the sticky add-bar,
         expose them as CSS vars on the section so hero + journey fit exactly */
      var heroEl = root.querySelector('.sb-hero');
      var stickyBar = root.querySelector('[data-sticky]');
      function fitHero() {
        if (heroEl) {
          root.style.setProperty('--sb-hero-offset', '0px');
          var top = heroEl.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
          root.style.setProperty('--sb-hero-offset', Math.max(top, 0) + 'px');
        }
        if (stickyBar) { root.style.setProperty('--sb-bar-h', (stickyBar.offsetHeight || 0) + 'px'); }
      }
      fitHero();
      window.addEventListener('load', fitHero);
      window.addEventListener('resize', fitHero);

      /* ---- hero gallery (Faithfull-style: thumbs on desktop, dots on mobile) ---- */
      var gal = root.querySelector('[data-gallery]');
      if (gal) {
        var gImgs = gal.querySelectorAll('.sb-gal__img');
        var gThumbs = gal.querySelectorAll('[data-gthumb]');
        var gDots = gal.querySelectorAll('[data-gdot]');
        var gIndex = 0;
        var stage = gal.querySelector('[data-gal-stage]');
        var sliding = false;
        var galMobile = function () { return window.matchMedia('(max-width:860px)').matches; };
        var galMarkActive = function (i) {
          gImgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
          gThumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
          gDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        };
        var galMarkNav = function (i) {
          gThumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
          gDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        };
        /* desktop: directional vertical slide between two images, loops seamlessly */
        var galSlideTo = function (target, dir) {
          if (!gImgs.length) return;
          if (target < 0) target = gImgs.length - 1;
          if (target >= gImgs.length) target = 0;
          if (target === gIndex || sliding) return;
          if (!dir) dir = target > gIndex ? 1 : -1;
          sliding = true;
          var cur = gImgs[gIndex], nxt = gImgs[target];
          nxt.classList.add('is-active');
          nxt.style.zIndex = '2'; cur.style.zIndex = '1';
          nxt.style.transition = 'none';
          nxt.style.transform = 'translateY(' + (dir > 0 ? '100%' : '-100%') + ')';
          void nxt.offsetWidth;
          var T = 'transform .72s cubic-bezier(.66,0,.18,1)';
          nxt.style.transition = T; cur.style.transition = T;
          nxt.style.transform = 'translateY(0)';
          cur.style.transform = 'translateY(' + (dir > 0 ? '-100%' : '100%') + ')';
          var done = function () {
            nxt.removeEventListener('transitionend', done);
            gIndex = target;
            gImgs.forEach(function (im, k) {
              im.style.transition = ''; im.style.transform = ''; im.style.zIndex = '';
              im.classList.toggle('is-active', k === target);
            });
            galMarkNav(target);
            sliding = false;
          };
          nxt.addEventListener('transitionend', done);
        };
        var galGoTo = function (i, fromScroll) {
          if (!gImgs.length) return;
          if (i < 0) i = gImgs.length - 1;
          if (i >= gImgs.length) i = 0;
          if (galMobile()) {
            gIndex = i;
            if (stage && !fromScroll) stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
            galMarkActive(i);
          } else {
            galSlideTo(i);
          }
        };
        gThumbs.forEach(function (t) { t.addEventListener('click', function () { galGoTo(+t.getAttribute('data-gthumb')); }); });
        gDots.forEach(function (d) { d.addEventListener('click', function () { galGoTo(+d.getAttribute('data-gdot')); }); });
        /* mobile: keep dots in sync while the user scrolls/swipes through */
        if (stage) {
          var scrollRaf = null;
          stage.addEventListener('scroll', function () {
            if (!galMobile() || !stage.clientWidth) return;
            if (scrollRaf) return;
            scrollRaf = requestAnimationFrame(function () {
              scrollRaf = null;
              var i = Math.round(stage.scrollLeft / stage.clientWidth);
              if (i !== gIndex) { gIndex = i; galMarkActive(i); }
            });
          }, { passive: true });
        }
        /* desktop: vertical wheel slides through images (loops); page stays locked */
        if (gImgs.length > 1) {
          var wheelAcc = 0;
          gal.addEventListener('wheel', function (e) {
            if (galMobile()) return;
            e.preventDefault();              /* lock the page while over the gallery */
            if (sliding) { wheelAcc = 0; return; }
            wheelAcc += e.deltaY;
            if (Math.abs(wheelAcc) < 18) return;   /* small trackpad nudges accumulate */
            var dir = wheelAcc > 0 ? 1 : -1;
            wheelAcc = 0;
            galSlideTo(gIndex + dir, dir);
          }, { passive: false });
        }
        /* let variant selection jump the gallery to that variant's media */
        root.__sbGalByMedia = function (mediaId) {
          if (mediaId == null) return false;
          for (var k = 0; k < gImgs.length; k++) {
            if (gImgs[k].getAttribute('data-media-id') === String(mediaId)) { galGoTo(k); return true; }
          }
          return false;
        };
      }

      /* native Horizon variant-picker handles selection markup/a11y; we resolve the variant
         LOCALLY (no fetch dependency) and update price/stock/image/url/hidden-id instantly */
      var sbPicker = root.querySelector('variant-picker.sb-vp');
      var sbDataEl = root.querySelector('[data-sb-variants]');
      if (sbPicker && sbDataEl) {
        var SB_VARIANTS = [];
        try { SB_VARIANTS = JSON.parse(sbDataEl.textContent); } catch (err) { SB_VARIANTS = []; }
        var sbResolve = function () {
          var sel = [];
          sbPicker.querySelectorAll('fieldset').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            if (c) sel.push(c.value);
          });
          return SB_VARIANTS.filter(function (x) {
            return x.options.length === sel.length && x.options.every(function (o, i) { return o === sel[i]; });
          })[0];
        };
        var sbStock = function (v) {
          if (!v || !v.available) return { t: 'Sold out', c: 'no' };
          if (v.managed && v.qty > 0 && v.qty <= 2) return { t: 'Only ' + v.qty + ' left', c: 'low' };
          return { t: 'In stock', c: 'ok' };
        };
        var sbEsc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); };
        var sbFieldsets = sbPicker.querySelectorAll('fieldset');
        var sbStickySelects = root.querySelectorAll('[data-sb-sticky-opts] select');
        var sbApply = function () {
          sbFieldsets.forEach(function (fs, i) {
            var c = fs.querySelector('input:checked');
            var ch = fs.querySelector('.sb-vp__chosen');
            if (c && ch) ch.textContent = c.value;
            /* keep the sticky-bar dropdowns in sync */
            sbStickySelects.forEach(function (s) {
              if (+s.getAttribute('data-sb-sticky-pos') === i && c) s.value = c.value;
            });
          });
          /* sync the mirror picker (buy box): chosen labels + active states */
          var sel = [];
          sbFieldsets.forEach(function (fs) { var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null); });
          root.querySelectorAll('[data-sb-mirror] .sb-vp__opt').forEach(function (opt, i) {
            var ch = opt.querySelector('.sb-vp__chosen');
            if (ch && sel[i] != null) ch.textContent = sel[i];
            opt.querySelectorAll('.sb-vp__choice').forEach(function (b) {
              b.classList.toggle('is-active', b.getAttribute('data-sb-mval') === sel[i]);
            });
          });
          var v = sbResolve();
          if (!v) return;
          if (hiddenId) { hiddenId.value = v.id; hiddenId.dispatchEvent(new Event('change', { bubbles: true })); }
          root.querySelectorAll('.js-price').forEach(function (p) { p.textContent = v.price; });
          var stt = sbStock(v);
          var statusHtml = '<span class="sb-vp__price js-price">' + sbEsc(v.price) + '</span>' +
            (v.was ? '<span class="sb-vp__was">' + sbEsc(v.was) + '</span>' : '') +
            '<span class="sb-vp__stock ' + stt.c + '">' + stt.t + '</span>';
          root.querySelectorAll('[data-sb-status]').forEach(function (s) { s.innerHTML = statusHtml; });
          if (root.__sbGalByMedia && v.mediaId != null) root.__sbGalByMedia(v.mediaId);
          if (v.img) {
            var sep = v.img.indexOf('?') > -1 ? '&' : '?';
            var thumb = root.querySelector('.sb-stickybar__thumb img');
            if (thumb) { thumb.src = v.img + sep + 'width=120'; thumb.removeAttribute('srcset'); }
          }
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', u.toString());
          } catch (e2) {}
        };
        sbPicker.addEventListener('change', sbApply);

        /* helper: select a value on the primary picker by option position */
        var sbSelect = function (pos, val) {
          var fs = sbFieldsets[pos];
          if (!fs) return;
          var radio = fs.querySelector('input[value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
          if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        };

        /* sticky-bar dropdowns -> drive the primary picker (which re-runs sbApply) */
        sbStickySelects.forEach(function (s) {
          s.addEventListener('change', function () { sbSelect(+s.getAttribute('data-sb-sticky-pos'), s.value); });
        });

        /* mirror picker (buy box) -> drive the primary picker */
        root.querySelectorAll('[data-sb-mirror] [data-sb-mval]').forEach(function (b) {
          b.addEventListener('click', function () {
            sbSelect(+b.getAttribute('data-sb-mpos'), b.getAttribute('data-sb-mval'));
          });
        });
      }

      /* if the native fetch DOES resolve (live store), mirror its payload too — harmless duplicate */
      root.addEventListener('variant:update', function (e) {
        var d = e.detail; if (!d) return;
        var html = d.data && d.data.html;
        var v = d.resource;
        if (html) {
          var newStatus = html.querySelector('[data-sb-status]');
          var curStatus = root.querySelector('[data-sb-status]');
          if (newStatus && curStatus) curStatus.innerHTML = newStatus.innerHTML;
          var newPrice = html.querySelector('.sb-vp__price');
          if (newPrice) {
            root.querySelectorAll('.js-price').forEach(function (p) { p.textContent = newPrice.textContent.trim(); });
          }
        }
        if (v && v.id) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', u.toString());
          } catch (err) {}
        }
        if (v && v.featured_media) {
          if (root.__sbGalByMedia) root.__sbGalByMedia(v.featured_media.id);
          var src = v.featured_media.preview_image && v.featured_media.preview_image.src;
          if (src) {
            var sep = src.indexOf('?') > -1 ? '&' : '?';
            var thumb = root.querySelector('.sb-stickybar__thumb img');
            if (thumb) { thumb.src = src + sep + 'width=120'; thumb.removeAttribute('srcset'); }
          }
        }
      });

      /* secondary "Add to bag" buttons submit the real Horizon form (opens drawer) */
      root.querySelectorAll('.js-add[data-proxy]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!form) return;
          if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
        });
      });

      /* accordions */
      root.querySelectorAll('.sb-acc__btn').forEach(function (b) {
        b.addEventListener('click', function () { b.parentElement.classList.toggle('is-open'); });
      });

      /* scroll reveals */
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { threshold: 0.2 });
      root.querySelectorAll('.sb-reveal').forEach(function (el) { io.observe(el); });
      var jr = root.querySelector('[data-sb-journey]');
      if (jr) { new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) en.target.classList.add('in'); }); }, { threshold: 0.35 }).observe(jr); }

      /* sticky bar after hero, hidden near the buy zone */
      var bar = root.querySelector('[data-sticky]');
      var hero = root.querySelector('.sb-hero');
      var buy = root.querySelector('#sb-buy');
      if (bar && hero) { new IntersectionObserver(function (es) { es.forEach(function (en) { bar.classList.toggle('show', !en.isIntersecting); }); }, { threshold: 0 }).observe(hero); }
      if (bar && buy) { new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) bar.classList.remove('show'); }); }, { threshold: 0.2 }).observe(buy); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sebbi-quotes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sb-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-sb-track]');
      var prev = root.querySelector('[data-sb-prev]');
      var next = root.querySelector('[data-sb-next]');
      var arrows = root.querySelector('[data-sb-arrows]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.sb-quote');
        if (!card) return track.clientWidth;
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var scrollable = track.scrollWidth - track.clientWidth > 4;
        if (arrows) arrows.hidden = !scrollable;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
